import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom';
import { adsContext } from '../UseContext/AdsContext';
import AdFinalPreviewPopup from '../Popup/Campaign/AdFinalPreviewPopup';


const LeadGeneration = () => {

  const navigate = useNavigate();

  const buttons = ['Shop Now', 'Contact Us', 'Download', 'Buy Now', 'Whatsapp', 'Apply Now', 'Learn More', 'Call Now', 'Enquire Now', 'Visit Website', 'Book Now', 'Install Now', 'Subscribe', 'Play Game'];

  // const checkboxes = ['User Name', 'City', 'Age', 'State', 'Mobile Number', 'Gender', 'Address'];

  const { 
    ad, setAd,
    setShowAdFinalPreviewPopup,
  } = useContext(adsContext);
  
  return (
    <>
      {/* Ad Final Preview Popup */}
      <AdFinalPreviewPopup />

      <section className='d-flex flex-column flex-xl-row gap-3 mb-3'>
        {/* Left Block */}
        <div className='create-campaign-left-block bg-light p-3 rounded-3 shadow-sm'>
          {/* Action & Custom Button */}
          <div className='bg-white p-3 rounded-3 mb-3'>
            <div className="form-check mt-4">
              <input className="form-check-input mt-2" type="radio" id="action" name="buttonType" checked={ad.buttonType === 'action'} onChange={() => setAd({ ...ad, buttonType: 'action', buttonName: '' })} />
              <label className="form-check-label fs-5 d-block fw-semibold" htmlFor="action">Action Button</label>
              <small className='text-secondary'>A headline is required, Complete the field to publish.</small>

              <div className='border row mx-auto p-3 rounded-3 mt-2'>
                {
                  buttons.map((value, index) => (
                    <div className="form-check col-sm-6 col-md-4 mb-3" key={index}>
                      <input className="form-check-input" type="radio" name='buttonName' id={`action-button-${index}`} 
                        value={value} checked={ad.buttonName === value} onChange={(e) => setAd({ ...ad, [e.target.name]: value })}
                      />
                      <label className="form-check-label" htmlFor={`action-button-${index}`}>{value}</label>
                    </div>
                  ))
                }
              </div>
            </div>

            <div className="form-check mt-4">
              <input className="form-check-input mt-2" type="radio" id="custom" name="buttonType" checked={ad.buttonType === 'custom'} onChange={() => setAd({ ...ad, buttonType: 'custom', buttonName: '' })} />
              <label className="form-check-label fs-5 d-block fw-semibold" htmlFor="custom">Custom Button</label>
              <small className='text-secondary'>A headline is required, Complete the field to publish.</small>
              <input type="text" className='form-control mt-1' name='buttonName' disabled={ad.buttonType !== 'custom'} placeholder='Enter a short heading...' 
                value={ad.buttonType === 'custom' ? ad.buttonName : ''} onChange={(e) => setAd({ ...ad, [e.target.name]: e.target.value })} 
              />
            </div>
          </div>

          {/* Destination */}
          <div className='bg-white p-3 rounded-3 mb-3'>
            <h5 className='mb-0'>Destination</h5>

            <small className='text-secondary'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Nobis, quia.</small>

            {/* Mobile Number */}
            <div className='border p-3 rounded-3 mt-3'>
              <div className="">
                <h5 className="mb-0" htmlFor="custom">Enter link, Mobile Number & etc...</h5>
                <small className='text-secondary'>Enter link, Mobile Number & etc...</small>
                <input type="text" className='form-control mt-1' name='buttonLink' placeholder='Enter link, Mobile Number & etc...'
                  value={ad.buttonLink} onChange={(e) => setAd({ ...ad, [e.target.name]: e.target.value })}  
                />
              </div>
            </div>

            {/* Fill Form */}
            {/* <div className='border p-3 rounded-3 mt-3'>
              <div className="">
                <h5 className="mb-0" htmlFor="custom">Fill Form</h5>
                <small className='text-secondary'>Send people to your Telegram, WeChat & WhatsApp.</small>

                <div className='row mx-auto mt-3 '>
                  {
                    checkboxes.map((value, index) => (
                      <div className="form-check mb-3 col-sm-6" key={index}>
                        <input className="form-check-input" type="checkbox" name='checkboxes' id={`checkbox-${index}`} defaultChecked={index === 0} />
                        <label className="form-check-label" htmlFor={`checkbox-${index}`}>{value}</label>
                      </div>
                    ))
                  }
                </div>
              </div>
            </div> */}

            {/* Mobile Number */}
            {/* <div className='border p-3 rounded-3 mt-3'>
              <div className="">
                <h5 className="mb-0" htmlFor="custom">Mobile Number</h5>
                <small className='text-secondary'>Send people to your Telegram, WeChat & WhatsApp.</small>
                <input type="text" className='form-control mt-1' placeholder='Enter mobile number...' />
              </div>
            </div> */}

            {/* Messaging Apps */}
            {/* <div className='border p-3 rounded-3 mt-3'>
              <div className="">
                <h5 className="mb-0" htmlFor="custom">Messaging Apps</h5>
                <small className='text-secondary'>Send people to your Telegram, WeChat & WhatsApp.</small>

                <h5 className='mb-0 mt-3'>Message Templage</h5>
                <small className='text-secondary'>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Velit voluptate exercitationem, natus animi voluptatibus sequi reiciendis nesciunt corrupti et recusandae unde necessitatibus dolorem tempore ducimus ea vero perferendis nemo fugit.</small>

                <div className='bg-light p-3 rounded-3 my-3'>
                  <h5 className='mb-0'>Greeting</h5>
                  <small className='text-secondary'>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Aperiam, optio.</small>
                  <h5 className='my-3'>Questions and Responses</h5>

                  <ul>
                    <li className='mb-3'>
                      <span className='d-block'>Can i make a purchase?</span>
                      <span className='text-secondary'>Add a response [Optional]</span>
                    </li>

                    <li className='mb-3'>
                      <span className='d-block'>Can i make a purchase?</span>
                      <span className='text-secondary'>Add a response [Optional]</span>
                    </li>

                    <li className='mb-3'>
                      <span className='d-block'>Can i make a purchase?</span>
                      <span className='text-secondary'>Add a response [Optional]</span>
                    </li>
                  </ul>
                </div>

                <div className='d-flex align-items-center justify-content-end gap-3'>
                  <button type="button" className='btn border rounded-4 d-flex align-items-center gap-1'>
                    <img src="/images/icons/dashboard-black.svg" style={{ height: '20px' }} alt="edit" />
                    <span>Edit</span>
                  </button>

                  <button type="button" className='btn border rounded-4 d-flex align-items-center gap-1'>
                    <img src="/images/icons/dashboard-black.svg" style={{ height: '20px' }} alt="edit" />
                    <span>Delete</span>
                  </button>
                </div>
              </div>
            </div> */}
          </div>

          {/* Buttons */}
          <div className='d-flex align-items-center justify-content-between gap-3 flex-wrap'>
            <button type="button" className='btn btn-success flex-grow-1'>Save Draft</button>
            <button type="button" className='btn bg-secondary-subtle text-primary flex-grow-1' onClick={() => navigate(`/campaigns/parameters`)}>Show Preview</button>
            <button type="button" className='btn bg-secondary-subtle flex-grow-1'>Cancel</button>
            <button type="button" className='btn btn-primary flex-grow-1' onClick={() => setShowAdFinalPreviewPopup(true)}>Next</button>
          </div>
        </div>

        {/* Right Block */}
        <div className='create-campaign-right-block bg-light p-3 rounded-3 shadow-sm'>Right Block</div>
      </section>  
    </>
  );
};

export default LeadGeneration;